import React from 'react';
import { View, ViewStyle } from 'react-native';

import { useIsLargeScreen } from '@/hooks/use-is-large-screen';

export const Row: React.FC<{ children: React.ReactNode, style?: ViewStyle }> = ({ children, style }) => {
	const isLargeScreen = useIsLargeScreen();
	return <View
		style={[
			style,
			isLargeScreen ? {
				flexDirection: 'row',
				gap: 16,
			} : { },
		]}
	>
		{children}
	</View>;
};
